module.exports = __webpack_public_path__ + "img/arrow-down-black.4dba1048.svg";